<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <app-notificacoes-perfis *ngIf="mensagens" [notificacaoMensagens]="mensagens"
                               [notificacaoStatus]="statusSucesso" (fecharNotificacoes)="mensagens = []">
      </app-notificacoes-perfis>
    </div>
    <div class="col-4">
      <h2>Criando um novo perfil</h2>
    </div>
    <!--    {{permissoesAcessoUsuario | json}}-->
    <div class="col-md-4 text-center">
      <p>Modo de visualização</p>
      <button class="btn btn-secondary" (click)="alterarVisualizacao('novo')">Menu Remissivo</button>
      <button class="btn btn-secondary" (click)="alterarVisualizacao('tradicional')">Menu Tradicional</button>

      <div *ngIf="modoVisualizacao == 'tradicional'">
        <div class="col text-center selecao-menus">
          <button name="menu1" type="button" class="btn btn-secondary"
                                                                
                  *ngIf="permissoesAcessoUsuario.includes(108) && menulinha1"
                  (click)="trocarArvoreSendoExibida($event)">Menu Linha 1
          </button>
          <button name="menu2" type="button" class="btn btn-secondary"
                  *ngIf="permissoesAcessoUsuario.includes(109) && menulinha2"
                  (click)="trocarArvoreSendoExibida($event)">Menu Linha 2
          </button>
          <button name="menu3" type="button" class="btn btn-secondary"
                  *ngIf="permissoesAcessoUsuario.includes(2445) && menulinha3"
                  (click)="trocarArvoreSendoExibida($event)">Funcionalidade
          </button>
        </div>
      </div>

    </div>
    <div class="col-md-4  text-end">
      <button class="btn btn-terceary" routerLink="/perfis">
        <i class="fa fa-undo" aria-hidden="true"></i> Voltar para lista de perfis
      </button>
    </div>

  </div>
  <div class="row">
    <div class="col-4 ">
      <label class="col-form-label">Nome do perfil</label>
      <div class="input-group">
        <input type="text" [(ngModel)]="nomePerfil" class="form-control" aria-describedby="passwordHelpInline">
        <button class="btn btn-terceary"
                [disabled]="(selecoes.length < 2 && permissoesSelecionadas.length < 2) || nomePerfil == '' || perfilEnviado"
                (click)="salvarPerfil()">
          Criar Perfil
        </button>
      </div>

    </div>
    <div class="col-8 cssSelecoes">
      <ul *ngIf="selecoes.length > 2">
        <li style="padding-bottom: 15px;"> Abaixo alguns dos acessos selecionados</li>
        <li *ngFor="let p of selecoes.slice(0,10) " [innerHTML]="formatarCaminhoLongo(p)" ></li>
      </ul>
    </div>
  </div>
</div>
<hr>
<div *ngIf="modoVisualizacao == 'tradicional'">

  <div class="container-fluid" style="background-color: #ccc;" *ngIf="menuSendoMostrado">
    <div class="row">
      <div class="col">
        <org-chart [topEmployee]="menuSendoMostrado" direction="vertical"
                   (itemClick)="mostrarSequencia($event)"></org-chart>
      </div>
    </div>
  </div>

  <hr *ngIf="menuSendoMostrado && arvoreSendoMostrada">
  <div class="container" *ngIf="mostrarArvoreSelecionada">
    <div class="row">
      <div class="col">
        <org-chart
          [topEmployee]="arvoreSendoMostrada" direction="horizontal"
                   (itemClick)="onClickItemE($event)"></org-chart>
      </div>
    </div>
  </div>
</div>


<div *ngIf="modoVisualizacao == 'novo'">
  <div class="container">
    <div class="row form-group">
      <h2>Lista de Acessos</h2>
      <div class="col input-group">
        <input type="search" name="filtrarDados" class="form-control" placeholder="Ex. cadastros" #filtro
               aria-describedby="btn-filtro">
        <button class="btn btn-secondary" id="btn-filtro" type="button"
                (click)="searchObjects(filtro.value)">Filtrar dados...
        </button>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col">
        <app-perfil-unico *ngFor="let item of indiceRemissivoFiltrado" 
        [indiceRemissivo]="item"
        [userGuid]="usuario.guid"
        (indiceSelecionadoEvent)="marcarComoSelecionado($event)">
      </app-perfil-unico>
        <p *ngIf="indiceRemissivoFiltrado.length < 1">Nenhum perfil com a palavra
          <strong>{{ filtro.value }}</strong>
          foi encontrado!
        </p>
      </div>
    </div>

  </div>
</div>
